import { types as mediasoupTypes } from "mediasoup-client";

export interface VideoOptions {
    WEB_APP_SERVER_URL: string;
    EMS_SERVER_URL: string;
    VIDEO_SERVER_URL: string;
    IS_PRODUCER: boolean;
}

declare global {
    interface Window {
        videoOptions: VideoOptions;
        switchCamera?: () => Promise<boolean>;
        toggleFlashlight?: () => Promise<boolean>;
        isFlashlightAvailable?: () => boolean;
        isFlashlightOn?: () => boolean;
    }
}

export const videoOptions = window.videoOptions;

// maximum snapshot image chunk size for sending
export const MAX_CHUNK_SIZE = 12000;

// detect integrated video mode (ELS live video)
export const isIntegratedMode: boolean = navigator.userAgent.includes('Live');

// https://mediasoup.org/documentation/v3/mediasoup-client/api/#transport-produce
// One adaptive encoding — NO simulcast. For this topology (one phone uplink feeding 1-2
// dispatchers who always want the maximum) a single stream is strictly better: the send-side BWE
// (transport-cc) adapts the encoder target to the uplink, and degradationPreference (set after
// produce) decides what to sacrifice under pressure. Simulcast would split the constrained uplink
// across layers the SFU would never serve, plus cost phone CPU and extra keyframes.
//
// maxBitrate is a CEILING, not a target — the BWE governs the actual bitrate, so a high ceiling is
// safe on weak links (BWE caps lower automatically) and lets a fat 5G/Wi-Fi uplink spend everything
// on one sharp 1080p60 stream. videoGoogleStartBitrate seeds the initial BWE estimate high so
// quality ramps in seconds instead of ~48 s of slow AIMD; on Safari it also anchors the operating
// bitrate (Safari does not probe upward). See Docs/External/WebRTC/ng-sos-video-parameters.md §2.
export const producerOptionsVideo: mediasoupTypes.ProducerOptions = {
  encodings: [{ maxBitrate: 12_000_000, maxFramerate: 60 }],
  codecOptions: { videoGoogleStartBitrate: 6000 },
};
